export const REPORT_CONFIG = {
    'daily-personal-horoscope': {
        slug: 'daily-personal-horoscope',
        urlSlug: 'daily-personal-horoscope',
        title: 'Your Daily Cosmic Roadmap',
        metaTitle: 'Daily Personal Horoscope - Accurate Vedic Predictions',
        metaDescription: 'Start every day with clarity. Get your personalized daily horoscope, auspicious timings, and remedies based on your birth chart.',
        icon: "https://img.icons8.com/emoji/48/sun-emoji.png",
        heroImage: "/hero-horoscope.png",
        description: "Navigate your day with confidence. Know exactly when to act and when to pause with your personalized daily astrological guide.",
        benefits: [
            "📌 Precise predictions based on your unique Birth Chart",
            "⏳ Golden Hours: Your most auspicious timings (Muhurta)",
            "⚠️ Rahu Kaal Alert: avoid setbacks effectively",
            "🛡️ Daily Remedies: Simple fixes for daily challenges"
        ],
        benefitIcons: [
            "ri-map-pin-user-fill",
            "ri-timer-flash-fill",
            "ri-alarm-warning-fill",
            "ri-shield-star-fill"
        ],
        price: 99,
        reportType: 'daily-personal-horoscope'
    },
    'love-compatibility': {
        slug: 'love-compatibility',
        urlSlug: 'love-compatibility',
        title: 'Love & Relationship Compatibility',
        metaTitle: 'Love Compatibility Report - Vedic Matchmaking',
        metaDescription: 'Is he/she the one? Get a detailed Vedic compatibility analysis (Guna Milan) to understand your emotional & spiritual connection.',
        icon: "https://img.icons8.com/emoji/48/red-heart.png",
        heroImage: "/hero-love.png",
        description: "Discover the true potential of your connection. Go beyond surface-level chemistry and understand your deep spiritual compatibility.",
        benefits: [
            "❤️ Detailed Guna Milan (36-Point Match Analysis)",
            "🧠 Mental & Emotional wavelength compatibility",
            "🚧 Identify potential friction points before they arise",
            "✨ Vedic Remedies to strengthen your bond"
        ],
        benefitIcons: [
            "ri-heart-pulse-fill",
            "ri-brain-line",
            "ri-road-map-fill",
            "ri-magic-line"
        ],
        price: 199,
        reportType: 'love-compatibility'
    },
    'career-forecast': {
        slug: 'career-forecast',
        urlSlug: 'career-forecast',
        title: 'Career Growth & Success Forecast',
        metaTitle: 'Career Growth Forecast - Job Upgrade & Success',
        metaDescription: 'Stuck in your career? Unlock your golden periods for growth, promotion, and success with our detailed Career Forecast.',
        icon: "./launch.png",
        heroImage: "/hero-career.png",
        description: "Don't leave your career to chance. Align your hard work with cosmic timing to maximize your professional success.",
        benefits: [
            "🚀 Identify your upcoming Golden Period for growth",
            "💼 Job vs. Business: What suits your destiny best?",
            "🛑 Foresee and mitigate workplace challenges",
            "📅 Annual roadmap for promotions and switches"
        ],
        benefitIcons: [
            "ri-rocket-2-fill",
            "ri-briefcase-4-fill",
            "ri-stop-circle-fill",
            "ri-calendar-event-fill"
        ],
        price: 299,
        reportType: 'career-forecast'
    },
    'financial-outlook': {
        slug: 'financial-outlook',
        urlSlug: 'financial-outlook',
        title: 'Wealth & Financial Prosperity Report',
        metaTitle: 'Financial Outlook Report - Wealth & Money',
        metaDescription: 'Secure your financial future. Discover wealth accumulation yoga, investment timings, and risk periods in your horoscope.',
        icon: "./money-bag.png",
        heroImage: "/hero-finance.png",
        description: "Unlock the secrets to your financial stability. Know when to invest, when to save, and how to attract abundance.",
        benefits: [
            "💰 Your natural wealth-accumulating potential",
            "📈 Best periods for high-return investments",
            "⚠️ Risk Radar: Times to avoid speculation or loans",
            "🗝️ Gemstone & Mantra remedies for financial flow"
        ],
        benefitIcons: [
            "ri-money-dollar-circle-fill",
            "ri-stock-line",
            "ri-radar-fill",
            "ri-key-2-fill"
        ],
        price: 299,
        reportType: 'financial-outlook'
    },
    'marriage-timing': {
        slug: 'marriage-timing',
        urlSlug: 'marriage-timing',
        title: 'Marriage Timing & Partner Prediction',
        metaTitle: 'Marriage Timing Report - When Will You Marry?',
        metaDescription: 'Curious about marriage? Find out when you match is likely to happen, partner characteristics, and remedies for delays.',
        icon: "./wedding-ring.png",
        heroImage: "/hero-marriage.png",
        description: "When will you meet 'The One'? Unveil the timing, nature, and characteristics of your future life partner.",
        benefits: [
            "📅 Precise timelines for marriage prospects",
            "🤵 Personality traits & profession of your future spouse",
            "⏳ Reasons for delay and effective remedies",
            "💞 Post-marriage happiness and harmony predictions"
        ],
        benefitIcons: [
            "ri-calendar-check-fill",
            "ri-user-heart-fill",
            "ri-hourglass-fill",
            "ri-hearts-fill"
        ],
        price: 399,
        reportType: 'marriage-timing'
    },
    'health-wellness': {
        slug: 'health-wellness',
        urlSlug: 'health-wellness',
        title: 'Health Vitality & Wellness Report',
        metaTitle: 'Health & Wellness Report - Vedic Medical Astrology',
        metaDescription: 'Prioritize your well-being. Uncover physical strengths, vulnerable periods, and lifestyle changes suited to your body type.',
        icon: "./healthcare.png",
        heroImage: "/hero-health.png",
        description: "Your birth chart holds that key to your vitality. Proactively manage your well-being with ancient Vedic wisdom.",
        benefits: [
            "🏥 Predict vulnerable health periods in advance",
            "💪 Analysis of your immunity level (Lagna Strength)",
            "🥗 Dietary & lifestyle tips for your unique constitution",
            "🧘 Spiritual remedies for chronic issues"
        ],
        benefitIcons: [
            "ri-hospital-line",
            "ri-arm-fill",
            "ri-leaf-fill",
            "ri-mental-health-fill"
        ],
        price: 249,
        reportType: 'health-wellness'
    },
    'childbirth-predictions': {
        slug: 'childbirth-predictions',
        urlSlug: 'childbirth-predictions',
        title: 'Progeny & Childbirth Report',
        metaTitle: 'Childbirth Predictions Report - Fertility & Parenting',
        metaDescription: 'Planning a family? Get insights into fertility timings, conception, and parenting based on your Jupiter placement.',
        icon: "./baby-boy.png",
        heroImage: "/hero-child.png",
        description: "Embrace the journey of parenthood with clarity. Understand favorable timings for conception and your parenting path.",
        benefits: [
            "👶 Best periods for conception vs. periods of care",
            "👨‍👩‍👧 Your potential and style as a parent",
            "🚧 Remedies for obstacles in conceiving",
            "🌟 Overview of your child's health and happiness"
        ],
        benefitIcons: [
            "ri-parent-fill",
            "ri-team-fill",
            "ri-barricade-fill",
            "ri-star-smile-fill"
        ],
        price: 349,
        reportType: 'childbirth-predictions'
    },
    'job-vs-business': {
        slug: 'job-vs-business',
        urlSlug: 'job-vs-business',
        title: 'Job vs. Business Dilemma Solver',
        metaTitle: 'Job vs Business Report - Career Direction',
        metaDescription: 'Confused between a stable job or a startup? Let your horoscope decide your most profitable path.',
        icon: "./business.png",
        heroImage: "/hero-job-business.png",
        description: "Stop guessing. Align your career choice with your birth chart's natural inclination for maximum success and satisfaction.",
        benefits: [
            "⚖️ Definitive verdict: Job, Business, or Both?",
            "💼 Success probability in corporate vs. entrepreneurship",
            "📉 Risk appetite assessment from your chart",
            "🔁 Favorable timelines for making the switch"
        ],
        benefitIcons: [
            "ri-scales-3-fill",
            "ri-briefcase-2-fill",
            "ri-funds-box-fill",
            "ri-refresh-line"
        ],
        price: 299,
        reportType: 'job-vs-business'
    },
    'personality-report': {
        slug: 'personality-report',
        urlSlug: 'personality-report',
        title: 'In-Depth Personality Analysis',
        metaTitle: 'Personality Report - Self Discovery',
        metaDescription: 'Understand the "Why" behind your actions. A deep psychological and spiritual analysis of your true self.',
        icon: "./thinking.png",
        heroImage: "/hero-personality.png",
        description: "Master your own mind. Discover your hidden strengths, conquer your weaknesses, and understand your life's karmic purpose.",
        benefits: [
            "🦁 Core strengths & leadership qualities",
            "🥺 Emotional blindspots and triggers",
            "🎨 Hidden talents waiting to be unlocked",
            "🌀 Karmic life lessons you are here to learn"
        ],
        benefitIcons: [
            "ri-user-5-fill",
            "ri-emotion-sad-line",
            "ri-palette-fill",
            "ri-loop-right-fill"
        ],
        price: 199,
        reportType: 'personality-report'
    },
    'planetary-transits': {
        slug: 'planetary-transits',
        urlSlug: 'planetary-transits',
        title: 'Planetary Transit Impact',
        metaTitle: 'Transit Impact Report - Saturn, Jupiter, Rahu',
        metaDescription: 'How do current planetary movements affect YOU? Get a personalized transit report for the upcoming 6 months.',
        icon: "./planets.png",
        heroImage: "/hero-transits.png",
        description: "The planets are always moving. Stay one step ahead by knowing how major shifts (Saturn, Jupiter, Rahu) impact your life right now.",
        benefits: [
            "🪐 Effects of Saturn (Sade Sati/Dhaiya) & Jupiter",
            "⚡ Immediate changes triggered by current transits",
            "🏠 Which area of life is being activated now?",
            "🛡️ Protective remedies for tough transit phases"
        ],
        benefitIcons: [
            "ri-planet-fill",
            "ri-flashlight-fill",
            "ri-home-4-fill",
            "ri-shield-cross-fill"
        ],
        price: 299,
        reportType: 'planetary-transits'
    },
};
